import React, {FC} from 'react';
import {
    EquipmentRepairRequestStatusEnum,
    useEquipmentRepairRequestAddStatusMutation
} from "../../../../../../graphql/graphQlApiHooks";
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField} from "@mui/material";
import {Box} from "@mui/system";
import {LoadingButton} from "@mui/lab";


interface Props {
    open: boolean,
    onClose: () => void,
    equipmentRepairRequestId: string
}
const RecognisedImpracticalDialog: FC<Props> = ({open, onClose, equipmentRepairRequestId}) => {

    const [comment, setComment] = React.useState('');
    const [addStatus, {loading}] = useEquipmentRepairRequestAddStatusMutation()

    const submitHandler = () => {
        addStatus({
            variables: {
                equipmentRepairRequestId,
                state: {
                    status: EquipmentRepairRequestStatusEnum.RepairRecognisedImpractical,
                    comment
                }
            }
        }).then(() => {
            onClose();
            setComment('')
        })
    };


    return (
        <Dialog
            open={open}
            onClose={() => {
                onClose();
                setComment('')
            }}
        >
            <DialogTitle>
                Не подлежит ремонту
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Укажите причину, по которой оборудование не подлежит ремонту
                </DialogContentText>
                <Box
                    mt={2}
                >
                    <TextField
                        label="Причина по которой оборудование не подлежит ремонту"
                        multiline
                        rows={4}
                        variant="outlined"
                        required={true}
                        fullWidth
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                        size={'small'}
                    />
                </Box>
            </DialogContent>

            <DialogActions>
                <Button
                    onClick={() => {
                        onClose();
                        setComment('')
                    }}
                    size={'small'}
                >
                    Отмена
                </Button>
                <LoadingButton
                    loading={loading}
                    variant={'contained'}
                    size={'small'}
                    disabled={!comment}
                    onClick={submitHandler}
                >
                    Не подлежит ремонту
                </LoadingButton>
            </DialogActions>

        </Dialog>
    );
}

export default RecognisedImpracticalDialog;